var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import $ from 'jquery';
import environment from '@square/environment-utils/environment';
const env = environment();
const PAYKIT_STAGING = 'https://kit.cashstaging.app/v1/pay.js';
const PAYKIT_PROD = 'https://kit.cash.app/v1/pay.js';
const payKitScriptSource = env.isProduction && PAYKIT_PROD || PAYKIT_STAGING;
const CLIENT_ID_STAGING = 'CA0-CI_SQUARE-BANKING';
const CLIENT_ID_PROD = 'CA-CI_SQUARE-BANKING';
const clientId = env.isProduction && CLIENT_ID_PROD || CLIENT_ID_STAGING;
// Pay Kit doc: https://developers.cash.app/docs/pay-kit-getting-started
let CashAppPayKitSdk = (_class = class CashAppPayKitSdk extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sentry", _descriptor, this);
    _defineProperty(this, "restart", () => Promise.resolve());
  }
  async initialize({
    container,
    redirectURL,
    onSuccessCallback,
    onDismissCallback,
    onDeclineCallback,
    actionData,
    isMobileFlow
  }) {
    try {
      if (!window.CashApp?.pay) {
        // eslint-disable-next-line ember/no-jquery
        await $.getScript(payKitScriptSource);
      }
      const pay = await window.CashApp?.pay({
        clientId
      });

      // event listeners

      onDismissCallback && pay.addEventListener('CUSTOMER_DISMISSED', function _onDismissCallback() {
        onDismissCallback && onDismissCallback();
        pay.removeEventListener('CUSTOMER_DISMISSED', _onDismissCallback);
      });
      onDeclineCallback && pay.addEventListener('CUSTOMER_REQUEST_DECLINED', onDeclineCallback);
      onSuccessCallback && pay.addEventListener('CUSTOMER_REQUEST_APPROVED', result => {
        onSuccessCallback(result);
      });
      if (isMobileFlow) {
        return;
      }
      const controls = await this.render(pay, container, redirectURL, actionData);
      if (!controls.begin || !controls.restart) {
        throw new Error('Cash App Pay Kit: failed to load.');
      }
      this.restart = controls.restart;
      return controls;
    } catch (error) {
      this.sentry.captureException(error);
      return null;
    }
  }
  async render(pay, container, redirectURL, actionData) {
    const {
      begin
    } = await pay.render(container, {
      button: false,
      manage: false
    });
    await pay.customerRequest({
      actions: {
        deposits: {
          primaryAlias: actionData.primary_alias,
          logoURL: actionData.logo_url
        }
      },
      redirectURL,
      referenceId: `refId-${Date.now()}`
    });
    return {
      begin,
      restart: pay.restart
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CashAppPayKitSdk as default };